<template>
  <v-tooltip bottom color="white">
    <template v-slot:activator="{ on }">
      <v-icon v-if="row.propsStructure.obsolete" left v-on="on" color="success">
        mdi-checkbox-marked-circle
      </v-icon>
      <v-icon v-else v-on="on" left>mdi-close</v-icon>
    </template>
    <span v-if="row.propsStructure.compounded" class="black--text">
      This is a normal drug
    </span>
    <span v-else class="black--text">This is an obsolete drug</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => ({
        propsStructure: {
          computed: false
        }
      })
    }
  },
  methods: {}
};
</script>
